<template>
  <v-dialog v-model="dialog" max-width="600" :persistent="feedback.persistent">
    <v-card light>
      <v-toolbar elevation="0">
        <v-toolbar-title class="headline">
          {{ feedback.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog" v-if="!feedback.persistent">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-4 pb-0">
        <v-alert :type="feedback.type" prominent>
          <div
            class="d-flex"
            :class="feedback.events ? 'flex-column' : 'flex-row'"
          >
            <div>
              {{ feedback.msg }}
            </div>
            <div v-show="feedback.events" class="d-flex flex-column">
              <span class="body-2" v-for="event in feedback.events">
                {{ event }}
              </span>
            </div>
          </div>
        </v-alert>
      </v-card-text>
      <v-card-actions class="pb-4 px-4 flex-column">
        <div class="flex-grow-1"></div>

        <!-- <v-btn depressed @click="dialog = !dialog">FECHAR</v-btn> -->

        <!-- Action: Login -->
        <v-btn
          block
          depressed
          class="info my-1 mx-0"
          v-if="feedback.action === 'login'"
          @click="
            [
              $router.push({ name: 'Login', hash: '#loginPage' }),
              (dialog = !dialog),
            ]
          "
        >
          &nbsp;LOGIN&nbsp;
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>

        <!-- Action: Refresh -->
        <v-btn
          block
          depressed
          class="info my-1 mx-0"
          v-if="feedback.action === 'refresh'"
          @click="[$router.go(''), (dialog = !dialog)]"
        >
          &nbsp;{{ $t("btnRefresh") }}&nbsp;
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <!-- Action: CopyCode -->
        <v-btn
          block
          depressed
          class="info my-1 mx-0"
          v-if="feedback.copy === true && feedback.id_bet"
          @click="[$copy(feedback.id_bet), (dialog = !dialog)]"
        >
          &nbsp;{{ this.$t("btnCopy") }}&nbsp;
          <v-icon right>mdi-content-copy</v-icon>
        </v-btn>

        <!-- 
          Action: Share WhatsApp 
        -->
        <v-btn
          block
          depressed
          class="success my-1 mx-0"
          v-if="feedback.whatsapp === true && feedback.id_bet"
          :href="whatsappUrl"
          target="_blank"
          @click="$gtag.share('Whatsapp', 'id_bet', feedback.id_bet)"
        >
          &nbsp;WhatsApp&nbsp;
          <v-icon right>mdi-share</v-icon>
        </v-btn>

        <v-btn
          block
          v-if="!$isAgent() && feedback.id_bet"
          @click="$bet.shareBetTicket(feedback.id_bet)"
          depressed
          color="primary"
          class="my-1 mx-0"
        >
          {{ $t("shareCoupon") }}
          <v-icon right>mdi-share-variant</v-icon>
        </v-btn>

        <v-btn
          v-if="$domain() == 'elitexbetcom' && !$isAgent() && feedback.id_bet"
          @click="openCasaDeApostas"
          block
          depressed
          class="my-1 mx-0"
          color="info"
        >
          {{ $t("viewInCasaDeApostas") }}
          <v-icon right>mdi-eye-arrow-right-outline</v-icon>
        </v-btn>

        <!-- 
          Action: PrintBet 
        -->
        <v-btn
          block
          depressed
          class="info my-1 mx-0"
          v-if="feedback.action === 'printBet'"
          @click="[printBet(), (dialog = !dialog)]"
        >
          <span v-if="!$vuetify.breakpoint.smAndDown"
            >&nbsp;{{ $t("toPrint") }}&nbsp;</span
          >
          <v-icon :right="!$vuetify.breakpoint.smAndDown">mdi-printer</v-icon>
        </v-btn>

        <!-- 
         Action Sharebet PDF
        -->
        <v-btn
          block
          v-if="feedback.shareBetPDF && !isApple"
          depressed
          @click="shareBet()"
          color="red"
          class="my-1 mx-0"
          style="color: white"
        >
          <span v-if="!$vuetify.breakpoint.smAndDown"
            >&nbsp;{{ $t("downloadPDF") }}&nbsp;</span
          >
          <v-icon :right="!$vuetify.breakpoint.smAndDown">mdi-download</v-icon>
        </v-btn>

        <!-- Expired Events Action -->
        <v-btn
          v-if="feedback.action == 'open_drawer' && !$isAgent()"
          @click="openCouponDrawer"
          class="my-1 mx-0"
          depressed
          block
          color="green"
          style="color: white"
          append-icon="mdi-delete"
        >
          {{ $t("yesContinue") }}
          <v-icon right dark>
            mdi-page-next-outline
          </v-icon>
        </v-btn>
        <v-btn
          v-if="feedback.action == 'open_drawer' && !$isAgent()"
          @click="clearCart"
          class="my-1 mx-0"
          depressed
          block
          color="red"
          style="color: white"
        >
          {{ $t("cleanCart") }}
          <v-icon right dark>
            mdi-delete
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "feedback",
  data() {
    return {
      dialog: false,
      isApple: false,
    };
  },
  mounted() {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      this.isApple = true;
    }
    // console.log(this.$permissions().url);
    // console.log(this.feedback.id_bet);
  },
  computed: {
    feedback() {
      // Use: this.$store.commit('setFeedback', { title:'', msg: '', type:'', action: ''})
      // feedback.title = string
      // feedback.msg = string
      // feedback.type = string (success, warning, error, info)
      // feedback.action = string (login, refresh);
      return this.$store.state.feedback;
    },
    whatsappUrl() {
      // var msg = this.$isAgent()
      //   ? `https://wa.me/?text=Aposta%20codigo:%20${this.feedback.id_bet}%20 realizada, solicite o comprovante impresso ou em PDF!`
      //   : `https://wa.me/?text=Codigo:%20${this.feedback.id_bet}.%20https://${window.location.hostname}/home/conferencia/${this.feedback.id_bet}`;
      var operatorUrl = this.$store.state.operators.url
        ? this.$store.state.operators.url
        : `https://${window.location.hostname}/`;

      if (operatorUrl.includes("sullbet")) {
        operatorUrl = "https://www.sullbetoff.com/";
      }

      var msg = !this.feedback.validated
        ? `https://api.whatsapp.com/send?text=Aposta%20a%20validar:%20${this.feedback.id_bet}.%20${operatorUrl}home/conferencia/${this.feedback.id_bet}`
        : `https://api.whatsapp.com/send?text=Aposta%20validada:%20${this.feedback.id_bet}.%20${operatorUrl}home/conferencia/${this.feedback.id_bet}`;
      return msg;
    },
    // idBet() {
    //   return this.feedback.id_bet;
    // },
  },
  watch: {
    feedback() {
      this.dialog = true;
    },
    dialog(val) {
      if (!val) {
        if (this.$route.path.includes("bet/success")) {
          this.$router.go(-1);
        }
      }
    },
  },
  methods: {
    printBet: async function() {
      await this.$bet.getBetAgent(this.feedback.id_bet, 1);
      this.$printBet();
    },

    shareBet: async function() {
      this.$store.commit("setShareBet", true);
      await this.$bet.getBetAgent(this.feedback.id_bet, 1);
      this.$shareBet(); // Plugin-print.js
    },

    openCouponDrawer() {
      this.dialog = false;

      // Abre o bilhete após a confirmação "ok", do feedback de eventos expirados
      this.$store.commit("setOpenCouponAfterExpiredEventsFeedback");
    },

    clearCart() {
      this.dialog = false;

      this.$store.commit("setCoupons", []);
    },
    openCasaDeApostas() {
      const bancaId = 1116;
      const betId = this.feedback.id_bet;
      const url = `https://casadasapostas.net/bilhete?banca=${bancaId}&codigo=${betId}`;
      window.open(url, "_blank");
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
